import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
import listRepresentation from './listRepresentation'
import login from './login'
import paymentRepresentation from './paymentRepresentation';
import listSalonOwner from './listSalonOwner';
import entryAndEditListSalonOwner from './entryAndEditListSalonOwner';
import paySalonOwner from './paySalonOwner';
import managementCommissionAndGender from './managementCommissionAndGender';
import listCups from './listCups';
import entryAndEditListCup from './entryAndEditListCup';
import teams from './teams';
import gameTab from './gameTab';
import entryAndEditListTabScorersAndKnockoutAndGroup from './entryAndEditListTabScorersAndKnockoutAndGroup';
import hall from './hall';
import managementTodaySalon from './managementTodaySalon';
import playerList from './playerList';
import walletPlayer from './walletPlayer';
import playerDescription from './playerDescription';










export default new Vuex.Store({
  state: {
    showSidebar : false,
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    listRepresentation,
    login,
    paymentRepresentation,
    listSalonOwner,
    entryAndEditListSalonOwner,
    paySalonOwner,
    managementCommissionAndGender,
    listCups,
    entryAndEditListCup,
    teams,
    gameTab,
    entryAndEditListTabScorersAndKnockoutAndGroup,
    hall,
    managementTodaySalon,
    playerList,
    walletPlayer,
    playerDescription,
  }
})
